import axios from "axios";
import { productsData } from "../../data/productsData";
import { getHref, postHref } from "./httpMethods";

const BASE_URL = process.env.REACT_APP_API_DOMAIN;

export const isLocalMocks = BASE_URL.includes("localhost:8080"); // Note: port is important since `yarn start:test` has BASE_URL=http://localhost:8010/proxy

export const withPath = (path) => `${BASE_URL}/${path}`;

export const getSiteConfig = () => axios.get(process.env.REACT_APP_CONFIG_URL);

export async function getMergedProducts() {
  const { data } = await getHref(withPath(`v1/products`));

  return data.map((product) => {
    const matching = productsData.find(
      (productData) => productData.product_id === product.id,
    );

    return matching ? { ...matching, ...product } : product;
  });
}

export async function getAccounts() {
  return getHref(withPath("v2/accounts"));
}

export async function getAccount(id) {
  return getHref(withPath(`v1/accounts/${id}`));
}

export const getAccountWebview = async (id, token) =>
  getHref(
    withPath(`v1/accounts/${id}`),
    {},
    {
      Authorization: token,
      "X-Session-ID": window.sessionStorage.getItem("sessionId"),
    },
    false,
  );

export async function getPersonalLoanAccount(id) {
  return getHref(withPath(`v1/loans/personal/accounts/${id}`));
}

export async function getAccountLinks() {
  return getHref(withPath("v1/links"));
}

export async function postEvents({ data }) {
  const id = window.sessionStorage.getItem("sessionId");
  return postHref(withPath(`v1/events`), data, { "X-Session-ID": id }, false);
}

export async function postLinkOtp({ id, data }) {
  return postHref(withPath(`v2/links/${id}/otp`), data);
}

export async function postResendOtp(id) {
  return postHref(withPath(`v2/links/${id}/otp/resend`));
}

export async function postAccountLink({ data }) {
  return postHref(withPath(`v2/links`), data);
}

export async function getBalance(id) {
  return getHref(withPath(`v1/accounts/${id}/balance`));
}

export async function getStatements(id) {
  return getHref(withPath(`v1/documents/accounts/${id}/statements`));
}

export async function getUserProduct(id) {
  return getHref(withPath(`v1/products/${id}`));
}

export const postPayIn = (url, paymentDetails) => postHref(url, paymentDetails);

export async function postMigrateToOkta(credentials) {
  return postHref(withPath(`v1/okta-migration-api/migrate`), credentials);
}
